module.exports = __webpack_public_path__ + "static/media/endingHunger.bc17cc21.png";